/**
 * Neutral (no assistant-runtime-boundary) home for scroll-position math shared across features
 * that each independently need to align an element to the top of its scroll container or the
 * window. Kept separate from any single feature's own directory so it can be imported by both
 * Trip Chat's chat-scroll runtime and the offer-page assistant's focus executor without either
 * crossing the other's internal import boundary.
 */

/**
 * scrollTop that aligns an element's top with the scroll container's top, optionally leaving
 * `offset` px of clearance above it (e.g. a sticky header's height). Prefer getBoundingClientRect
 * deltas over element.offsetTop -- nested elements (list wrappers, date separators) often make
 * offsetTop not container-relative, landing a re-pin mid-way.
 */
export function getScrollTopToAlignElementTop(args: {
  containerScrollTop: number
  containerTop: number
  elementTop: number
  offset?: number
}): number {
  return Math.max(0, args.containerScrollTop + (args.elementTop - args.containerTop) - (args.offset ?? 0))
}

/**
 * Absolute page Y position that aligns an element's top with the given offset from the
 * viewport's own top (positive offset lands the element that far below the viewport top).
 */
export function getWindowScrollTopForElementTop(elementTop: number, offset = 0): number {
  return window.pageYOffset + elementTop + offset
}
